
import { AxiosInstance } from "axios";
import ApiClient from "./ApiClient";
import { MatchingOverviewData, MenteeMatchOverview, MatchCandidate } from "../types/Matching";

// Base URL for Mentoring Fusion API
const API_URL = process.env.REACT_APP_MENTORING_API_URL ?? "";

class MatchingService {
  private apiClient: AxiosInstance;

  constructor() {
    this.apiClient = new ApiClient(API_URL).getClient();
  }


  public getMatchingOverview = async (
    organizationId: string,
    campaignId: string
  ): Promise<MatchingOverviewData> => {
    return this.generateSampleData();
  };


  public generateSampleData = (): MatchingOverviewData => {
    const menteeCount = 50;
    const mentorCount = 30;

    // Helper to split names
    const split = (full: string) => {
      const [first, ...rest] = full.split(" ");
      return { first, last: rest.join(" ") };
    };

    const mentees: MenteeMatchOverview[] = Array.from({ length: menteeCount }, (_, idx) => {
      const menteeName = `Mentee ${idx + 1} Smith`;
      const { first: first_name, last: last_name } = split(menteeName);

      // shuffle mentor list to create scores
      const matches: MatchCandidate[] = Array.from({ length: mentorCount }, (_, idx) => {
        const mentorName = `Mentor ${idx + 1} Johnson`;
        const { first: mf, last: ml } = split(mentorName);
        const score = Math.floor(Math.random() * 41) + 60; // 60-100
        const matchable = Math.random() > 0.2; // 80% chance
        return { first_name: mf, last_name: ml, score, matchable };
      }).sort((a, b) => b.score - a.score);

      const matchedFlag = Math.random() < 0.3;
      const matched_mentor = matchedFlag ? { first_name: matches[0].first_name, last_name: matches[0].last_name } : undefined;

      return {
        first_name,
        last_name,
        matched: matchedFlag,
        matched_mentor,
        possible_matches: matches,
      };
    });

    return { mentees };
  };
}

const matchingService = new MatchingService();
export default matchingService;
